import updateTo2025 from '../migrations/01-update-2025';

const migrations = [updateTo2025];

export default migrations;
